<script>
import html2canvas from "html2canvas";
import VueQRCodeComponent from "vue-qrcode-component";

export default {
  components: {
    VueQRCodeComponent,
  },
  props: {
    title: {
      type: String,
    },
    fullName: {
      type: String,
    },
    date: {
      type: String,
    },
    Id: {
      type: String,
    },
    qrCodeContent: {
      type: String,
    },
  },
  methods: {
    // print card
    async download() {
      const el = this.$refs.printcontent;
      const options = { type: "dataURL" };
      const printCanvas = await html2canvas(el, options);
      const link = document.createElement("a");
      link.setAttribute("download", this.Id + ".jpg");
      link.setAttribute(
        "href",
        printCanvas.toDataURL("image/jpg").replace("image/jpg", "image/octet-stream")
      );
      link.click();
    },
  },
};
</script>

<template>
  <div class="text-center print-cover">
    <div class="card-print con-print text-center" ref="printcontent">
      <h5>{{ title }}</h5>
      <p><strong>الاسم :</strong> {{ fullName }}</p>
      <p><strong>تاريخ التقديم :</strong> {{ date }}</p>
      <p><strong>رقم الاستمارة :</strong> {{ Id }}</p>
      <VueQRCodeComponent class="qr-code" :text="qrCodeContent"></VueQRCodeComponent>
      <hr />
      <div class="">
        <p class="mb-1">هيأة الحشد الشعبي</p>
        <p class="mb-0">المديرية العامة للعلاقات والخدمات الاجتماعية</p>
      </div>
    </div>
    <button
      type="button"
      id="btn3"
      @click="download"
      class="btn bg-color-blue font-color-white btn-sm mt-2"
    >
      حفظ وصل التسجيل
    </button>
  </div>
</template>
